// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ConvertEntityNotification(props: any) {
  return null;
}

export default ConvertEntityNotification;
